import * as React from 'react';
import * as problemQuestions from '../styles/problemQuestions.module.scss';

export const ProblemQuestions = () => {
  return (
    <section className={problemQuestions.problemQuestions}>
      <div className={'container'}>
        <div className={problemQuestions.problemQuestions__wrapper}>
          <ul className={problemQuestions.problemQuestions__list}>
            <li
              className={`${problemQuestions.problemQuestions__element} ${problemQuestions.problemQuestions__elementOne}`}
            >
              <p className={problemQuestions.problemQuestions__text}>
                <b>Устали</b> каждый вечер после работы
                <br /> <b>зубрить</b> с ребёнком английские слова?
              </p>
            </li>
            <li
              className={`${problemQuestions.problemQuestions__element} ${problemQuestions.problemQuestions__elementTwo}`}
            >
              <p className={problemQuestions.problemQuestions__text}>
                <b>Репетиторы не решают проблему</b>
                <br /> с изучением языка, а только
                <br /> «подтягивают» оценки?
              </p>
            </li>
            <li
              className={`${problemQuestions.problemQuestions__element} ${problemQuestions.problemQuestions__elementThree}`}
            >
              <p className={problemQuestions.problemQuestions__text}>
                Хотите, чтобы ребёнок мог
                <br /> учить язык
                <br /> <b>без вашей помощи?</b>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
